<template>
    <div>

        <fieldset>
            <legend>{{ __('Stammdaten') }}</legend>
            <div class="row row-cols-1 row-cols-sm-2">
                <div class="col">
                    <text-input :floating="true" label="salutation" v-model="form.salutation" :error="form.errors.salutation" />
                </div>
                <div class="col">
                    <text-input :floating="true" label="title" v-model="form.title" :error="form.errors.title" />
                </div>
                <div class="col">
                    <text-input :floating="true" label="first_name" v-model="form.first_name" :error="form.errors.first_name" />
                </div>
                <div class="col">
                    <text-input :floating="true" label="last_name" v-model="form.last_name" :error="form.errors.last_name" />
                </div>
                <div class="col">
                    <text-input :floating="true" label="email" type="email" v-model="form.email" :error="form.errors.email" />
                </div>
            </div>
        </fieldset>

        <fieldset>
            <legend>{{ __('Password') }}</legend>
            <div class="row row-cols-1 row-cols-sm-2">
                <div class="col">
                    <text-input :floating="true" type="password" label="password" v-model="form.password" :error="form.errors.password" autocomplete="off" />
                </div>
                <div class="col">
                    <text-input :floating="true" type="password" label="password_confirmation" v-model="form.password_confirmation" :error="form.errors.password_confirmation" autocomplete="off" />
                </div>
            </div>
        </fieldset>

        <fieldset>
            <legend>{{ __('Sonstiges') }}</legend>
            <avatar class="mb-3" :user="user" style="max-height: 150px;" v-if="user" />
            <file-input :floating="true" :form="form" v-model="form.avatar" :error="form.errors.avatar" accept="image/*" label="Avatar" />
            <!--<input type="file" accept="image/*" @input="form.avatar = $event.target.files[0]" />-->

            <textarea-input :floating="true" label="notes" v-model="form.notes" :error="form.errors.notes" />
        </fieldset>

        <div class="d-flex justify-content-between align-items-center">
            <submit-button :form="form" />
<!--        @todo permissions    <button type="button" class="btn link-danger" @click="destroy">
                {{ __('Löschen') }}
            </button>-->
        </div>
    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import FileInput from '@/shared/Inputs/FileInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    
    import Avatar from '@/shared/Avatar';

    export default {
        props: [
            'form',
            'user',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            FileInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
            Avatar,
        },
        watch: {
        },
        methods: {
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('users.destroy', this.user))
                }
            },
        },
    }
</script>